import { h } from 'preact';

const ArrowDown = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" {...props}>
			<path fill-rule="evenodd" d="M15 29.585L7.45 21a1.003 1.003 0 0 0-1.416 0 1.003 1.003 0 0 0 0 1.416l9.259 10.291c.392.39 1.024.39 1.416 0L26 22.416A1.004 1.004 0 0 0 26 21a1.003 1.003 0 0 0-1.416 0L17 29.585V2a1 1 0 0 0-2 0v27.585z"/>
		</svg>
	);
};

export default ArrowDown;
